import React, { useState } from "react";
import { Eye, Presale } from "../../../IconTheme";
const data = [
	{
		key: "Sale Type",
		value: "Fair Launch",
	},
	{
		key: "Token Name",
		value: "ANTEX Token",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
	{
		key: "Sale Type",
		value: "Fair Launch",
	},
	{
		key: "Token Name",
		value: "ANTEX Token",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
	{
		key: "Sale Type",
		value: "Fair Launch",
	},
	{
		key: "Token Name",
		value: "ANTEX Token",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
	{
		key: "Sale Type",
		value: "Fair Launch",
	},
	{
		key: "Token Name",
		value: "ANTEX Token",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
	{
		key: "Token Symbol",
		value: "ANT",
	},
];
const PreSaleInfo = () => {
	const [viewAllOpen, setViewAllOpen] = useState(false);
	return (
		<div className="chart-card pb-0">
			<div className="price-chart-header d-flex flex-wrap align-items-center">
				<Presale />
				<h5 className="m-0 mt-1 ps-2">Pre-sale information</h5>
			</div>
			<div className="pre-sale-information position-relative">
				<ul
					className="pre-sale-information-list"
					style={{
						maxHeight: data.length > 4 && viewAllOpen ? "" : "300px",
					}}
				>
					{data.map((item, i) => (
						<li key={i}>
							<div className="left">
								<span
									style={{ transform: "translateY(2px)" }}
									className="d-inline-flex"
								>
									<span className="me-1">{item.key}</span>
								</span>
							</div>
							<div className="right">{item.value}</div>
						</li>
					))}
				</ul>
				{data.length > 4 && (
					<div
						className={`view-all-overlay ${viewAllOpen ? "" : "active"}`}
					>
						<button
							className="cmn-btn"
							type="button"
							onClick={() => setViewAllOpen(!viewAllOpen)}
						>
							<span>{!viewAllOpen ? "Show All" : "Show Less"}</span>{" "}
							<Eye />
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default PreSaleInfo;
